import { useConversations } from '@cascade/react/conversations';
import { useExperienceList } from '@cascade/react/experiences';
import { useI18n } from '@cascade/react/i18n';
import { Loading } from '@cascade/ui-library';
import clsx from 'clsx';
import { useEffect } from 'react';
import classes from './Home.module.scss';
import { AgentChat } from '#components/agent-chat/index.ts';
import { ExperienceExplorer } from '#components/experience-explorer/index.ts';
import { Page } from '#components/page/index.ts';

export const Home = () => {
  const { translate } = useI18n();
  const { currentConversationId, hasMessages, selectConversation } =
    useConversations();

  const { experiences, isLoadingExperiences } = useExperienceList();

  const hasExperiences = experiences.length > 0;
  const showExplorer = currentConversationId === undefined && !hasMessages;

  const isWaitingForExperiences = showExplorer && isLoadingExperiences;

  useEffect(() => () => selectConversation(), [selectConversation]);

  return (
    <Page>
      {isWaitingForExperiences ? (
        <Loading contain label={translate('pending.experiences')} />
      ) : (
        <div className={classes.home}>
          <div className={classes.chat}>
            <AgentChat />
          </div>
          {hasExperiences ? (
            <div
              className={clsx(classes.explorer, {
                [classes.collapsed]: !showExplorer,
              })}
            >
              <ExperienceExplorer experiences={experiences} />
            </div>
          ) : null}
        </div>
      )}
    </Page>
  );
};
